import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../Elements/Desktop/Home";
import About from "../Elements/Desktop/About";
import Contact from "../Elements/Desktop/Contact";
import Recent from "../Elements/Desktop/Recent";
import Resume from "../Elements/Desktop/Resume";
import ProjectMenu from "../Elements/Desktop/ProjectMenu";
import Menu from "../Elements/Desktop/Menu";
import { Projects } from "../../ProjectData";
import Project from "../Elements/Desktop/Project";

const Desktop = ({
  currentIndex,
  nextImage,
  prevImage,
  changeProject,
  setCurrentProject,
}) => {
  return (
    <div className="main">
      <ProjectMenu nextImage={nextImage} prevImage={prevImage} />
      <div className="content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/recent"
            element={<Recent changeProject={changeProject} />}
          />
          <Route path="/resume" element={<Resume />} />
          {Projects.map((project, index) => {
            const nextProject = Projects[(index + 1) % Projects.length];
            const prevProject =
              Projects[(index - 1 + Projects.length) % Projects.length];

            return (
              <Route
                key={project.route}
                path={`/recent/${project.route}`}
                element={
                  <Project
                    projectKey={project.key}
                    setCurrentProject={setCurrentProject}
                    title={project.title}
                    role={project.role}
                    billing={project.billing}
                    imageSrc={project.images?.[currentIndex]}
                    nextImage={nextImage}
                    prevImage={prevImage}
                    nextProject={nextProject}
                    prevProject={prevProject}
                    changeProject={changeProject}
                  />
                }
              />
            );
          })}

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Menu changeProject={changeProject} />
      </div>
    </div>
  );
};

export default Desktop;
